export default "__VITE_ASSET__84OSHPrN__"